import React, { createContext, useEffect, useState, useContext } from 'react';
import { getUserLogged } from '../api/auth';
import { reducerAuth, initialState } from '../reducers/auth';
import Login from '../views/Login';
import { Spinner } from '@chakra-ui/react';
import useIsMountedRef from '../hooks/useIsMountedRef';
import LoadingScreen from '../components/common/LoadingScreen';
import SessionTimeoutMonitor from '../components/SessionTimeoutMonitor';

export const AuthContext = createContext(initialState)
export function AuthProvider({ children }) {
    const [state, dispatch] = React.useReducer(reducerAuth, initialState);
    const isMountedRef = useIsMountedRef();

    const [localState, setState] = useState({
        status: 'pending',
        error: null,
        user: null,
    })

    useEffect(() => {
        if (isMountedRef.current) {
            if (!!localStorage.getItem('token') === false) {
                dispatch({ type: 'LOGOUT' })
                setState({ status: 'error', error: null, user: null })
            } else {
                getUserLogged().then(res => {
                    if (res.status === 200) {
                        const user = res.data.data.user;
                        dispatch({ type: 'USER_LOGGED', payload: { status: 'success', error: null, user: user } })
                        setState({ status: 'success', error: null, user: user })
                    }
                },
                    error => {
                        dispatch({ type: 'LOGOUT' })
                        setState({ status: 'error', error: error, user: null })
                        dispatch({ type: 'USER_LOGGED', payload: { status: 'error', error: error, user: null } })
                    }).catch(error => {
                        dispatch({ type: 'LOGOUT' })
                        setState({ status: 'error', error: error, user: null })
                        dispatch({ type: 'USER_LOGGED', payload: { status: 'error', error: error, user: null } })
                    })
            }
        }
    }, [isMountedRef])

    return (
        <AuthContext.Provider value={{ state, dispatch }}>
            <SessionTimeoutMonitor user={state.user} dispatch={dispatch} />
            {localState.status === 'pending' ? <LoadingScreen /> : (children) }
        </AuthContext.Provider>
    )
}

export function useAuthState() {
    const { state, dispatch } = useContext(AuthContext)
    const isPending = state.status === 'pending'
    const isError = state.status === 'error'
    const isSuccess = state.status === 'success'
    const isAuthenticated = state.user && isSuccess
    return {
        ...state,
        dispatch,
        isPending,
        isError,
        isSuccess,
        isAuthenticated,
    }
}
